import React from 'react';
import FeetLayout from '../../layouts/FeetLayout';
import FeedContent from './FeedContent';

const Feed = () =>
    <FeetLayout>
      <FeedContent />
    </FeetLayout>

export default Feed;